import React from 'react';
import {
  alpha,
  createTheme,
  ThemeProvider as MuiThemeProvider
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import { red } from '@material-ui/core/colors';
import { colorIsDark } from 'utils/invertColor';

const brandColors = {
  1: '#000000',
  2: '#D8B758',
  3: '#EFBF23',
  4: '#A53F38',
  5: '#888888',
  6: '#723E31',
  7: '#FFE155',
  8: '#C0C0C0',
  30: '#af803C',
  31: '#4C1748',
  32: '#E55E60',
  33: '#93408e',
  34: '#2D384C',
  35: '#000000',
  36: '#000000'
};

const ThemeProvider = props => {
  const user = useSelector(({ auth }) => auth.user);
  const primary =
    user && user.hairdresserSelected && user.hairdresserSelected.brands
      ? { main: `#${user.hairdresserSelected.brands?.color_primary}` }
      : user && user.group === 3 && user.brands?.length > 0
      ? { main: brandColors[user.brands[0]] }
      : { main: '#d3b16f' };

  const theme = createTheme({
    palette: {
      type: 'light',
      primary,
      secondary: {
        main: '#000000'
      },
      text: {
        dynamic: colorIsDark(primary.main)
          ? alpha('#fff', 0.85)
          : alpha('#000', 0.85)
      },
      error: red
    },
    props: {
      MuiTextField: {
        variant: 'outlined'
      },
      MuiMenu: {
        elevation: 0,
        getContentAnchorEl: null,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'center'
        }
      }
    },
    shape: {
      borderRadius: 16
    },
    overrides: {
      MuiDivider: {
        root: {
          height: 0.5,
          marginTop: 15,
          marginBottom: 15
        },
        horizontal: {
          marginTop: 5,
          marginBottom: 5
        }
      },
      MuiListItemIcon: {
        root: {
          minWidth: 40
        }
      },
      MuiOutlinedInput: {
        root: {
          borderRadius: 4
        }
      },
      MuiIcon: {
        fontSizeLarge: {
          fontSize: 50
        }
      },
      MuiButton: {
        root: {
          textTransform: 'none',
          borderRadius: 0
        },
        text: {
          padding: 10
        },
        sizeLarge: {
          padding: '10px 50px'
        },
        contained: {
          borderRadius: 0,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none'
          }
        }
      },
      MuiInputLabel: {
        formControl: {
          '&.MuiInputLabel-marginDense.MuiInputLabel-filled': {
            top: -3
          }
        }
      },
      MuiFilledInput: {
        inputMarginDense: {
          paddingTop: 16
        }
      },
      MuiMenu: {
        paper: {
          border: 'solid 1px rgba(224, 224, 224, 1)',
          marginTop: 8,
          maxHeight: 300
        }
      },
      MuiTableCell: {
        head: {
          '&:first-child': {
            borderTopLeftRadius: 10
          },
          '&:last-child': {
            borderTopRightRadius: 10
          }
        }
      },
      MuiTypography: {
        h2: {
          fontWeight: 'bold',
          fontSize: '2.65rem'
        },
        h3: {
          fontWeight: 500,
          fontSize: '2rem',
          lineHeight: 1.6
        },
        h5: {
          fontWeight: 600,
          fontSize: '2.4rem'
        },
        h6: {
          fontWeight: 700,
          fontSize: '1.5rem'
        },
        subtitle1: {
          fontSize: '1.4rem'
        }
      }
    },
    typography: {
      htmlFontSize: 10,
      body1: {
        fontSize: '1.4rem'
      },
      body2: {
        fontSize: '1.4rem'
      },
      fontFamily: ['Muli', 'Roboto', '"Helvetica",Arial,sans-serif']
    }
  });

  return <MuiThemeProvider {...props} theme={theme} />;
};

export default ThemeProvider;
